import logger from '@eventbrite/client-logger';

const GOOGLE_PAY_SDK_URL = 'https://pay.google.com/gp/p/js/pay.js';

const scriptExists = (source: string) =>
    document.querySelector(`script[src="${source}"]`) !== null;

const loadScript = (
    onScriptLoad: () => void,
    onScriptLoadError: () => void,
) => {
    const source = GOOGLE_PAY_SDK_URL;

    if (scriptExists(source)) {
        onScriptLoad();
        return;
    }
    const node = document.createElement('script');

    node.src = source;
    node.onload = onScriptLoad;
    node.onerror = onScriptLoadError;
    node.async = true;

    document.head.appendChild(node);
};

interface GooglePayScriptConfig {
    onScriptLoad: () => void;
    onScriptLoadError: () => void;
}

export const loadGooglePayScript = async (config: GooglePayScriptConfig) => {
    const { onScriptLoad, onScriptLoadError } = config;
    try {
        loadScript(onScriptLoad, onScriptLoadError);
    } catch (e) {
        onScriptLoadError();
        logger.error('Error loading Google Pay script: ', e);
    }
};
